import { get } from 'lodash-es';

class SelectTabPaneCtrl {
  state;

  selectedItem;

  unsubscribeFromStore;

  constructor(private UploadModel, private $scope) {
    'ngInject';
  }

  $onInit() {
    this.state = this.UploadModel.store.getState();
    this.selectedItem = get(this.state.worksheets, 'selectedWorksheetName');

    this.unsubscribeFromStore = this.UploadModel.store.subscribe(() => {
      this.state = this.UploadModel.store.getState();
      this.selectedItem = get(this.state.worksheets, 'selectedWorksheetName');
    });
  }

  $onDestroy() {
    this.unsubscribeFromStore();
  }

  isSelected(item) {
    return this.selectedItem === item;
  }

  selectTab(item) {
    let action = this.UploadModel.updateSelectedWorksheet(item);
    this.UploadModel.store.dispatch(action);
    let state = this.UploadModel.store.getState();

    this.selectedItem = get(state.worksheets, 'selectedWorksheetName');
  }
}

export const SelectTabPaneComponent = {
  template: require('./selectTabPane.component.html'),
  controller: SelectTabPaneCtrl
};
